import React from "react";

type LogoSize = "small" | "medium" | "large";

interface LicitarsLogoProps {
  size?: LogoSize;
}

const LicitarsLogo: React.FC<LicitarsLogoProps> = ({ size = "medium" }) => {
  const dimensions = {
    small: "w-10",
    medium: "w-32",
    large: "w-48",
  };

  return (
    <div className={`${dimensions[size]} flex flex-col items-center`}>
      <img src="/licitars-logo.jpeg" alt="LicitarsAI Logo" className="w-full" />
    </div>
  );
};

export default LicitarsLogo;
